import { useAxios } from '~/composables/useAxios'

export default function useStaff() {
  const { $get } = useAxios()

  async function getTroupe() {
    return await $get(`/api/v3/staff?category=Труппа&_sort=sortKey:asc`)
  }

  async function getInvitedArtists() {
    return await $get(
      `/api/v3/staff?category=Приглашенные артисты&_sort=sortKey:asc`
      
    )
  }

  async function getInvitedStaff() {
    return await $get(
      `/api/v3/staff?category=Приглашенные специалисты&_sort=sortKey:asc`
    )
  }

  async function getLeadership() {
    return await $get(`/api/v3/staff?category=Руководство&_sort=sortKey:asc`)
  }

  async function getStaff() {
    return await $get(
      `/api/v3/staff?category_nin=Приглашенные артисты&category_nin=Руководство&category_nin=Приглашенные специалисты&category_nin=Труппа&_sort=sortKey:asc`
    )
  }

  async function getStaffById(id) {
    return await $get(`/api/v3/staff/${id}`)
  }

  return {
    getTroupe,
    getInvitedArtists,
    getLeadership,
    getStaff,
    getInvitedStaff,
    getStaffById
  }
}
